module.exports = __webpack_public_path__ + "img/ueex-google-play.4a11f5f3.png";